import styled from '@emotion/styled';

interface TextButtonProps {
  variant?: 'primary' | 'secondary'; // primary: #5636F5, secondary: #35353D
  underline?: boolean; // Show underline under text
  size?: 'full' | 'auto' | 'sm'; // full: 100% width, auto: content width, sm: smaller font size
}

const TextButton = styled.button<TextButtonProps>`
  font-family: 'Poppins', sans-serif;
  font-size: ${({ size }) => (size === 'sm' ? '14px' : '16px')};
  font-weight: 600;
  line-height: normal;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  background-color: transparent;
  border: none;
  color: ${({ variant }) => (variant === 'secondary' ? '#35353D' : '#5636F5')};
  text-decoration: ${({ underline }) => (underline ? 'underline' : 'none')};
  width: ${({ size }) => (size === 'full' ? '100%' : 'auto')};
  cursor: pointer;

  &:hover {
    filter: brightness(0.8); /* Darkens text color slightly on hover */
  }

  &:active {
    filter: brightness(0.6); /* Darkens text color more on click */
  }
`;

TextButton.defaultProps = {
  variant: 'primary',
  underline: false,
  size: 'auto',
};

export default TextButton;
